module.exports = __webpack_public_path__ + "2b0d8d7190dca38f6444af7ba8ccfcc5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-skate.png
// module id = 3199
// module chunks = 0